module.exports = __webpack_public_path__ + "img/member_message_icon.9bb75b22.png";